module.exports = __webpack_public_path__ + "static/media/2DGACM11.e7ede50c.jpg";